// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__272Dl","colMin":"styles_colMin__1Ht9_"};